/**
 * Structured @mention bookkeeping for the DrawerMention hook.
 *
 * The picker knows the id of everything it offers, but the composer used to
 * insert only `@Label ` and throw the id away — so the server had to find the
 * label again inside the sentence, which broke on punctuation and never
 * covered Apps, Agents, Skills, Tools or Workflows at all.
 *
 * These are pure functions over a plain array so the rules (dedupe, prune,
 * serialize) can be tested without a DOM.
 */

const refKey = (ref) => `${ref.kind}:${ref.id || ref.label}`

/**
 * Returns the list with the candidate appended, or the SAME list when the
 * candidate is unusable or already registered.
 */
export function rememberMentionRef(refs, candidate) {
  const kind = candidate && candidate.type
  const label = candidate && candidate.value

  if (typeof kind !== "string" || !kind) return refs
  if (typeof label !== "string" || !label) return refs

  const id = typeof candidate.id === "string" && candidate.id ? candidate.id : null
  const ref = {kind, id, label}

  if (refs.some((existing) => refKey(existing) === refKey(ref))) return refs

  return refs.concat([ref])
}

/**
 * Drops every mention whose `@Label` no longer appears in the composer. A
 * mention the user deleted from the text is no longer a mention.
 */
export function pruneMentionRefs(refs, text) {
  const value = typeof text === "string" ? text : ""
  return refs.filter((ref) => value.includes(`@${ref.label}`))
}

/**
 * JSON for the hidden form field. Never throws: an empty field simply falls
 * back to the server's name matching, while a thrown stringify would abort the
 * input handler and wedge the composer.
 */
export function serializeMentionRefs(refs) {
  try {
    return JSON.stringify(refs)
  } catch (_e) {
    return "[]"
  }
}
